import { ApplicationConfig, ErrorHandler } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
//import { provideAnimations } from '@angular/platform-browser/animations';


import { ROUTES } from './shared/routes/app.routes';
import {
  provideHttpClient,
  withInterceptors
} from '@angular/common/http';
import {
  LogLevel,
  authInterceptor,
  provideAuth
} from 'angular-auth-oidc-client';
import { environment } from '@environments/environment';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ReactiveFormsModule } from '@angular/forms';
import { headerInterceptor } from '@shared/utilities/header-interceptor';
import { GlobalerrorhandlerService } from '@shared/services/errorhandler/globalerrorhandler.service';


export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(ROUTES, withViewTransitions()),
    provideAnimationsAsync(),
    MessageService,
    ConfirmationService,
    DialogService,
    ReactiveFormsModule,
    provideHttpClient(withInterceptors([authInterceptor(), headerInterceptor])),
    { provide: ErrorHandler, useClass: GlobalerrorhandlerService },
    provideAuth({
      config: 
        {
          authority: environment.adfsAuthority,
          redirectUrl: `${window.location.origin}/redirect`,
          postLoginRoute: `${window.location.origin}/redirect`,
          postLogoutRedirectUri: window.location.origin,
          clientId: environment.clientId,
          secureRoutes: [
            environment.apiUrl, 
            environment.crewBasicUrl, 
            environment.crewDetailUrl
          ],
          scope: "openid",
          autoUserInfo: false,
          responseType: "id_token token",
          silentRenew: true,
          silentRenewUrl: `${window.location.origin}/silent-refresh.html`,
          logLevel: LogLevel.Debug,
        }
    })
  ]
};
